import { useState, useRef } from 'react'
import Icon from './Icons'
import { useDropdownPosition } from '@forwardflow/hooks/component'

type DropDownType = {
   options: { value: string; label: string }[]
   onChange?: (selectedValue: string) => void
   onOpenChange: (isOpen: boolean) => void
}

export const DropDown: React.FC<DropDownType> = ({
   options,
   onChange,
   onOpenChange,
}) => {
   const [selectedItem, setSelectedItem] = useState(options[0])
   const [isOpen, setIsOpen] = useState(false)

   const dropdownRef = useRef<any>(null)

   const openUpwards = useDropdownPosition(dropdownRef, isOpen, options.length)

   const handleSelect = (stage: { value: string; label: string }) => {
      setSelectedItem(stage)
      setIsOpen(false)
      onChange?.(stage.value)
      toggleDropdown()
   }
   const toggleDropdown = () => {
      const newIsOpen = !isOpen
      setIsOpen(newIsOpen)
      onOpenChange(newIsOpen)
   }

   return (
      <>
         {isOpen && (
            <div
               className="fixed bg-[#4D4D4D]/70 inset-0 z-[5]"
               onClick={toggleDropdown}
            ></div>
         )}

         <div
            className="relative flex flex-col items-center flex-1 w-full rounded gap-x-1 bg-white/10 shadow-[0px_4px_39.1px_0px_rgba(0,0,0,0.25)] "
            ref={dropdownRef}
         >
            {/* dropdown head  */}
            <div
               className={`h-[40px] ${
                  isOpen ? 'z-20' : null
               } flex items-center gap-x-3 w-full px-3 cursor-pointer leading-none hover:bg-[#828282]/20`}
               onClick={toggleDropdown}
            >
               <img src="/images/fub-grey.png" alt="fub" />
               <div className="flex-1 text-white">{selectedItem.label}</div>
               <Icon
                  name="arrow-down"
                  width={8}
                  className={`transition-transform duration-300 ${
                     isOpen ? '-rotate-180' : ''
                  }`}
               ></Icon>
            </div>
            {/* dropdown body  */}
            {isOpen && (
               <div
                  className={`absolute flex flex-col gap-y-1 rounded-[4px] ${
                     openUpwards
                        ? 'bottom-[40px] border-b'
                        : 'top-[40px] border-t'
                  } left-0 right-0 w-full px-3 py-5  border-white/20 bg-[#525059] z-20`}
               >
                  {options.map((stage) => (
                     <div
                        key={stage.value}
                        className={`flex items-center h-[38px] border border-white/10 bg-[#828282]/10 rounded px-5 leading-none text-white cursor-pointer hover:bg-[#828282]/20 ${
                           stage.value === selectedItem.value
                              ? 'opacity-50 cursor-not-allowed'
                              : ''
                        }`}
                        onClick={() =>
                           stage.value !== selectedItem.value &&
                           handleSelect(stage)
                        }
                     >
                        {stage.label}
                     </div>
                  ))}
               </div>
            )}
         </div>
      </>
   )
}
